import { Row, Container } from '@grubhubprod/gh-cookbook-react';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetDepartmentName } from 'src/components/EnterpriseDepartmentDetails/EnterpriseDepartmentName/EnterpriseDepartmentHooks/departmentHooks';
import DepartmentNameEditMode from 'src/components/EnterpriseDepartmentDetails/EnterpriseDepartmentName/DepartmentNameEditMode';
import DepartmentNameDisplayMode from 'src/components/EnterpriseDepartmentDetails/EnterpriseDepartmentName/DepartmentNameDisplayMode';

export default function EnterpriseDepartmentDetailsName(): JSX.Element {
  const { corpid: corpId, departmentId } =
    useParams<{ corpid: string; departmentId: string }>();

  const [departmentName, setDepartmentName] = useState<string>(null);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const retrievedName = useGetDepartmentName(corpId, departmentId);

  useEffect(() => {
    setDepartmentName(retrievedName);
  }, [retrievedName]);

  function onNameSubmit(newDepartmentName: string) {
    setDepartmentName(newDepartmentName);
    onExitEdit();
  }

  function onEnterEdit() {
    setIsEditing(true);
  }

  function onExitEdit() {
    setIsEditing(false);
  }

  if (!departmentName) {
    return null;
  }
  return (
    <Container>
      <Row alignItems="flex-start" gutter={12}>
        {isEditing ? (
          <DepartmentNameEditMode
            corpId={corpId as string}
            departmentId={departmentId as string}
            departmentName={departmentName}
            submitSuccess={onNameSubmit}
            onCancel={onExitEdit}
          />
        ) : (
          <DepartmentNameDisplayMode
            departmentName={departmentName}
            changeToEditMode={onEnterEdit}
          />
        )}
      </Row>
    </Container>
  );
}
